<template>
  <div class="wrapper">
    <div class="panel" v-if="content.show">
      <div class="header"  v-if="!mobileWidth">
        <div class="title">
          <p style="font-weight: bold">
            {{ content.head }}
          </p>
          <at-button
            icon="icon-filter"
            style="width: 100%"
            @click="filter.show = true"
          >
            Фильтр
          </at-button>
          <div>
            <span style="font-size: smaller; color: #8a94a1">Группировка:</span>
            <at-select v-model="groupBy" style="width: 100%">
              <at-option value="depth">Глубина</at-option>
              <at-option value="work">Тип работ</at-option>
              <at-option value="manager">Руководитель</at-option>
            </at-select>
          </div>
        </div>
      </div>
      <div class="body" id="itemlist" style="scroll-behavior: smooth">
        <at-collapse :value="catIds" :key="updKey">
          <at-collapse-item
            v-for="(cat, catId) in cats"
            :key="catId"
            :disabled="grouppedBody[catId].length == 0"
          >
            <div slot="title">
              {{ cat.name }}
              <div
                style="float: right; height: 0"
                v-if="grouppedBody[catId].length > 0"
              >
                <at-badge :value="grouppedBody[catId].length">
                  <div
                    class="group-icon"
                    :style="'background-color: ' + cat.color"
                  />
                </at-badge>
              </div>
            </div>
            <div class="at-table at-table--normal">
              <div class="at-table__content">
                <div class="at-table__body">
                  <table>
                    <tbody class="at-table__tbody">
                      <tr
                        v-for="(item, index) in grouppedBody[catId]"
                        :key="index"
                      >
                        <td
                          class="at-table__cell"
                          @click="getBalloon(item)"
                          :style="
                            item.id == selectedPointId
                              ? 'border: 1px solid rgb(41, 191, 255);border-radius: 4px;background-color: rgba(82, 203, 255, 0.3);'
                              : ''
                          "
                        >
                          <b :id="'item_' + item.id">{{
                            item.properties.balloonContentHeader
                          }}</b>
                          <p>
                            <small>{{ info(item) }}</small>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </at-collapse-item>
        </at-collapse>
      </div>
      <span class="close" @click="$emit('close')"
        ><i class="icon icon-x"></i
      ></span>
    </div>
    <pointFilter
      @filter-confirm="
        $emit('filter-confirm');
        updKey++;
      "
    />
  </div>
</template>

<script>
import pointFilter from "./FilterComponent.vue";

export default {
  props: ["content", "body", "groupping", "selectedPointId"],
  computed: {
    mobileWidth() {
      return document.body.clientWidth <= 500;
    },
    filter() {
      return this.$store.state.filter;
    },
    groupBy: {
      get() {
        return this.groupping;
      },
      set(val) {
        this.updKey++;
        this.$emit("groupping-change", val);
      },
    },
    cats() {
      if (this.groupping == "depth")
        return this.$store.state.depths.data.filter((cat) => {
          return (
            this.filter.depth.length == 0 ||
            this.filter.depth.indexOf(String(cat.id)) != -1
          );
        });
      if (this.groupping == "work")
        return this.$store.state.works.data.filter((cat) => {
          return (
            this.filter.works.length == 0 ||
            this.filter.works.indexOf(String(cat.id)) != -1
          );
        });
      if (this.groupping == "manager")
        return this.$store.state.managers.data.filter((cat) => {
          return (
            this.filter.manager.length == 0 ||
            this.filter.manager.indexOf(cat.id) != -1
          );
        });
      return null;
    },
    catIds() {
      var res = Array();
      this.cats.forEach((cat, catId) => {
        if (this.grouppedBody[catId].length > 0) res.push(catId);
      });
      return res;
    },
    grouppedBody() {
      var res = Array();
      this.cats.forEach((cat) => {
        var content = this.body.filter((point) => {
          if (this.groupping == "depth")
            return Number(point.properties.depth) == Number(cat.id);
          if (this.groupping == "work") return point.properties.type == cat.id;
          if (this.groupping == "manager")
            return Number(point.properties.manager) == Number(cat.id);
        });
        res.push(content);
      });
      return res;
    },
  },
  data: () => ({
    updKey: 0,
  }),
  methods: {
    getBalloon(point) {
      this.$emit("point-select", point);
    },
    info(item) {
      if (this.groupping == "depth")
        return (
          item.properties.balloonContentFooter +
          " " +
          this.$store.getters.getWork(item.properties.type).name
        );
      if (this.groupping == "work")
        return (
          item.properties.balloonContentFooter +
          " " +
          this.$store.getters.getDepth(item.properties.depth).name
        );
      if (this.groupping == "manager")
        return (
          this.$store.getters.getWork(item.properties.type).name +
          " " +
          this.$store.getters.getDepth(item.properties.depth).name
        );
    },
  },
  components: {
    pointFilter,
  },
};
</script>

<style scoped>

*,
:after,
:before {
  box-sizing: border-box;
}

div p {
  margin: 0;
  padding: 0;
}
p {
  color: #3f536e;
  font-size: 14px;
}

.wrapper {
  left: 45px;
  top: 10px;
  outline: 0;
  position: absolute;
  width: fit-content;
  font-family: sans-serif;
}

.panel {
  position: relative;
  margin: 0 auto;
  border-radius: 4px;
  background-color: #fff;
  outline: none;
  width: 250px;
  left: 0px;
  top: 0px;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.header {
  padding: 12px 16px;
  color: #2c405a;
  font-size: 14px;
  line-height: 1.5;
  border-bottom: 1px solid #ececec;
  box-sizing: border-box;
}

.body {
  padding: 0;
  font-size: 13px;
  line-height: 1.5;
  overflow-y: auto;
  height: calc(100vh - 232px);
  box-sizing: border-box;
}

.close {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 13px;
  line-height: 1;
  overflow: hidden;
  cursor: pointer;
  float: right;
  font-weight: 700;
  opacity: 0.5;
  text-shadow: 0 1px 0 #fff;
}

.at-table {
  margin: -17px;
}

.group-icon {
  width: 20px;
  height: 20px;
  border: 1px solid #777;
  border-radius: 10px;
}
</style>
